import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { map, Observable, take } from 'rxjs';
import { ApiRouter } from '../../../../global/routes/api-routes';
import { Option } from '../../../../shared/interfaces/lookup-options.interfaces';
import { ORBIT_BUNDLE_SESSION_KEY } from '../../constants';
import { OrbitFormClaimService } from './orbit-form-claim.service';

@Injectable({
  providedIn: 'root',
})
export class OrbitLookupService {
  loadedInValues = signal<Record<string, Record<string, any>>>({});

  constructor(
    private http: HttpClient,
    private orbitFormClaimService: OrbitFormClaimService
  ) {}

  lookupOptionsForStep(config: Record<string, any>, searchTerm: string): Observable<Option[]> {
    if (config['isFreeTextSearch']) {
      return this.http
        .post<any[]>(ApiRouter.orbit.freeTextSearch(), {
          lineId: config['productGroupCode'],
          description: searchTerm,
          'X-Session-Bundle': sessionStorage.getItem(ORBIT_BUNDLE_SESSION_KEY),
        })
        .pipe(
          take(1),
          map((val: any[]) => {
            const currentValue = this.loadedInValues()['freetextsearch'] ?? {};

            const mappedData = val.map((item) => {
              const newItem = {
                title: item.problemId_descr,
                dataLabel: item.problemId_descr,
                value: {
                  ...item,
                  dataLabel: item.problemId_descr,
                },
              };
              if (!currentValue[newItem.dataLabel]) {
                currentValue[newItem.dataLabel] = newItem;
              }
              return newItem;
            });

            this.loadedInValues.update((val) => {
              val['freetextsearch'] = currentValue;
              return val;
            });

            return mappedData;
          })
        );
    }

    return this.http
      .post<any>(ApiRouter.orbit.formStepEndpoint('GetData'), {
        searchTerm,
        dataType: config['dataType'],
        dataCategory: config['dataCategory'],
        GUID: this.orbitFormClaimService.state.claimData.startTransaction['gUID'],
        'X-Session-Bundle': sessionStorage.getItem(ORBIT_BUNDLE_SESSION_KEY),
      })
      .pipe(
        take(1),
        map((value) => {
          const dataTypeKey = config['dataType'].toLowerCase();
          if (!this.loadedInValues()[dataTypeKey]) {
            this.loadedInValues.update((val) => {
              val[dataTypeKey] = {};
              return val;
            });
          }

          const currentValue = this.loadedInValues()[dataTypeKey];
          const mappedData = value.dataResult.map((item: any) => {
            if (!currentValue[item.dataLabel]) {
              currentValue[item.dataLabel] = item;
            }

            return {
              title: item.dataLabel,
              value: item,
            };
          });

          this.loadedInValues.update((value) => {
            value[dataTypeKey] = currentValue;
            return value;
          });

          return mappedData;
        })
      );
  }
}
